import { FC } from 'react';
import { Button, TextField } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PageURL } from 'router/pageURL';
import {
  ALL_FILTER_OPTION,
  productTypeFilterOptions,
  productRangeFilterOptions,
  productCategoryFilterOptions,
} from '../types';
import { createNewProductAccessUsers, IProductsToolbarProps } from './types';
import { Select } from 'components/common/Select';
import { ISelectOption } from 'components/common/Select/types';
import {
  defaultSelectOptionFormatter,
  formatProductRangeFilterOptions,
  formatMaxFTVOptions,
  formatProductTypeFilterOptions,
  formatProductCategoryFilterOptions,
} from './helpers';
import { Checkbox } from 'components/common';
import { AccessWrapper } from 'components/AccessWrapper';

export const ProductsToolbar: FC<IProductsToolbarProps> = ({ onSearch, productList, onFiltersChange }) => {
  return (
    <div className={'mb-2 flex items-center justify-between'}>
      <TextField
        onChange={onSearch}
        placeholder={'Search'}
        className={'rounded-md border border-blue-500 p-2'}
        inputProps={{
          'data-testid': 'productsSearchBar',
        }}
      />

      <section className={'flex grow justify-between'}>
        <div className={'flex grow items-center justify-center'}>
          <label htmlFor={'ftvFilter'} className={'ml-3'}>
            <FormattedMessage id={'product.filters.productCategory'} />
          </label>
          <Select
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'productCategoryFilter'}
            className={'grow pl-2'}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption) =>
              onFiltersChange('productCategory', option.value)
            }
            options={formatProductCategoryFilterOptions(productCategoryFilterOptions)}
            isOptionEqualToValue={(option: ISelectOption, selectedOption: ISelectOption) =>
              option.value === selectedOption.value
            }
            renderInput={(params: any) => <TextField {...params} />}
            data-testid={'productCategoryFilter'}
          />
        </div>

        <div className={'flex grow items-center justify-center'}>
          <label htmlFor={'ftvFilter'} className={'ml-3'}>
            <FormattedMessage id={'product.filters.FTV'} />
          </label>
          <Select
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'ftvFilter'}
            className={'grow pl-2'}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption) =>
              onFiltersChange('ftv', option.value)
            }
            options={formatMaxFTVOptions(productList)}
            isOptionEqualToValue={(option: ISelectOption, selectedOption: ISelectOption) =>
              option.value === selectedOption.value
            }
            renderInput={(params: any) => <TextField {...params} />}
            data-testid={'ftvFilter'}
          />
        </div>

        <div className={'flex grow items-center justify-center'}>
          <label htmlFor={'productTypeFilter'} className={'ml-3'}>
            <FormattedMessage id={'product.filters.productType'} />
          </label>
          <Select
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'productTypeFilter'}
            className={'grow pl-2'}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption) =>
              onFiltersChange('productType', option.value)
            }
            options={formatProductTypeFilterOptions(productTypeFilterOptions)}
            isOptionEqualToValue={(option: ISelectOption, selectedOption: ISelectOption) =>
              option.value === selectedOption.value
            }
            renderInput={(params: any) => <TextField {...params} />}
            data-testid={'productTypeFilter'}
          />
        </div>

        <div className={'flex grow items-center justify-center'}>
          <label htmlFor={'productRangeFilter'} className={'ml-3'}>
            <FormattedMessage id={'product.filters.productRange'} />
          </label>
          <Select
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'productRangeFilter'}
            className={'grow pl-2'}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption) =>
              onFiltersChange('productRange', option.value)
            }
            options={formatProductRangeFilterOptions(productRangeFilterOptions)}
            isOptionEqualToValue={(option: ISelectOption, selectedOption: ISelectOption) =>
              option.value === selectedOption.value
            }
            renderInput={(params: any) => <TextField {...params} />}
            data-testid={'productRangeFilter'}
          />
        </div>

        <div className={'flex grow items-center justify-center'}>
          <label htmlFor={'productStateFilter'} className={'ml-3'}>
            <FormattedMessage id={'product.filters.productState'} />
          </label>
          <Checkbox
            name={'productStateFilter'}
            onChange={event => onFiltersChange('isActiveProductsOnly', event.target.checked)}
            data-testid={'productStateFilter'}
          />
        </div>
      </section>
      <AccessWrapper accessGroups={createNewProductAccessUsers}>
        <Link to={PageURL.PRODUCTS_NEW} className={'text-white no-underline'}>
          <Button variant={'contained'}>Add new product</Button>
        </Link>
      </AccessWrapper>
    </div>
  );
};
